import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TimezoneSimplePipe } from './pipes/timezone-simple.pipe';
import { TimezoneNamePipe } from './pipes/timezone-name.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [TimezoneSimplePipe, TimezoneNamePipe],
  exports: [TimezoneSimplePipe, TimezoneNamePipe],
})
export class SharedUtilsTimeZonesModule {}
